import { render } from "./birthdays.vue?vue&type=template&id=13889ab3&scoped=true"
import script from "./birthdays.vue?vue&type=script&lang=js"
export * from "./birthdays.vue?vue&type=script&lang=js"

import "./birthdays.vue?vue&type=style&index=0&id=13889ab3&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13889ab3"]])

export default __exports__